import { API_ENDPOINT } from '@/config/runtime'

export const BEAM_ENDPOINT = API_ENDPOINT
